(function () {
  function showMedia(root, id) {
    if (!id) return;
    root.querySelectorAll('[data-slide]').forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-slide') === String(id)); });
    root.querySelectorAll('[data-thumb]').forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-thumb') === String(id)); });
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = [].slice.call(root.querySelectorAll('[data-option]'));
    var idInput = root.querySelector('input[name="id"]');
    var price = root.querySelector('[data-price]');
    var btn = root.querySelector('[data-add]');

    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(root, t.getAttribute('data-thumb')); });
    });

    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var chosen = selects.map(function (x) { return x.value; }).join('|');
        var v = variants.filter(function (x) { return x.options.join('|') === chosen; })[0];
        if (!v) {
          if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (price) {
          price.innerHTML = '<span class="price">' + (v.compare
            ? '<span class="price__sale">' + v.price + '</span> <s class="price__compare">' + v.compare + '</s>'
            : '<span>' + v.price + '</span>') + '</span>';
        }
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
        if (v.media) showMedia(root, v.media);
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(null, '', url.toString());
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product]').forEach(initProduct);
    document.querySelectorAll('.cart-qty').forEach(function (i) {
      i.addEventListener('change', function () { if (i.form) i.form.submit(); });
    });
    document.querySelectorAll('[data-autosubmit]').forEach(function (f) {
      f.addEventListener('change', function () { f.submit(); });
    });
  });
})();
